export const SIGN_IN_USER: 'SIGN_IN_USER' = 'SIGN_IN_USER';
export const SIGN_OUT_USER: 'SIGN_OUT_USER' = 'SIGN_OUT_USER';

export const REGISTER_USER_SUCCESS: 'REGISTER_USER_SUCCESS' = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILED: 'REGISTER_USER_FAILED' = 'REGISTER_USER_FAILED';

export const RECOVERY_REQUEST: 'RECOVERY_REQUEST' = 'RECOVERY_REQUEST';
export const RECOVERY_SUCCESS: 'RECOVERY_SUCCESS' = 'RECOVERY_SUCCESS';
export const RECOVERY_FAILED: 'RECOVERY_FAILED' = 'RECOVERY_FAILED';

export const RESET_SUCCESS: 'RESET_SUCCESS' = 'RESET_SUCCESS';
export const RESET_FAILED: 'RESET_FAILED' = 'RESET_FAILED';

export const SET_USER: 'SET_USER' = 'SET_USER';